export enum PredictionDirection {
  UP = 'UP',
  DOWN = 'DOWN',
}
